import React from "react";
import { withRouter } from "../_shared/withRouter";
import ForgotPasswordComponent from "../template/auth/forgotPassword";

const ForgotPassword = () => {
  return <ForgotPasswordComponent roleType={"superadmin"} role={"1"} />;
};

export default withRouter(ForgotPassword);
